module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d16a2c96bd97f214cc889b5bc3f921b4.svg";